import { Language } from '../enums/language.enum';

export const AVAILABLE_LANGUAGES: Language[] = [Language.EN];

export const FALLBACK_LANGUAGE = Language.EN;

export const LANGUAGE_LOCAL_STORAGE_KEY = 'app-language';
